import React, { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { ThemeProvider, createTheme } from '@mui/material/styles';

// Components
import { Header } from '../components';

// Config
import { app } from '../config';

// Styles
import CssBaseline from '@mui/material/CssBaseline';
import { MainWrapper, Main } from './app.styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

export const AppProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <RecoilRoot>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Header images={app.header.backgroundImages} />
        <MainWrapper>
          <Main>
            <Outlet />
            { children }
          </Main>
        </MainWrapper>
      </ThemeProvider>
    </RecoilRoot>
  );
};